var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrematante-score no-select"},[_vm._v(" SCORE: "),_c('span',{staticClass:"font-bold",class:_vm.scoreColor},[_vm._v(_vm._s(_vm.arrematante.score || 'Indefinido'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }